import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { isBlank } from '@ember/utils';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';
import { inject as service } from '@ember/service';

import LoginController from 'cio/pods/login/controller';
import LoginService from 'cio/services/login';

const Validations = {
  password(value: string) {
    if (isBlank(value)) {
      return 'Please enter your password';
    }

    return true;
  },
};

export default class LoginPassword extends Controller {
  @service login!: LoginService;
  @controller('login') loginController!: LoginController;

  _validations: FormValidations;

  constructor() {
    super(...arguments);

    this._validations = FormValidations.create({
      validations: Validations,
      context: this,
      modelKey: 'loginController',
    });
  }

  _submitTask = task(async (event: Event) => {
    event.preventDefault();

    try {
      await this._validations.validateModel();
    } catch (e) {
      // `validateModel` already found and set validation errors
      // return early to avoid executing real submit logic
      return;
    }

    await this.loginController.loginTaskEmailPassword.perform();
  });

  @action
  onPasswordInput(value: string) {
    this.loginController.set('password', value);
    this._validations.validateAttribute('password');
  }

  @action
  useDifferentEmail() {
    // necessary to avoid showing "empty password" error after new e-mail is entered, password route re-visited
    this._validations.clearErrors();

    return this.loginController.useDifferentEmail();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'login/password': LoginPassword;
  }
}
